import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

// Baseado na resposta do seu backend, este é o tipo do usuário
export interface User {
  id: string
  name: string
  email: string
  user_roles: number
  is_admin?: boolean | null
  is_master?: boolean | null
  telephone: string
  cpf: string
  salary: number
  birthday: string
  start_date: string
  end_date: string | null
  company: string
  photo: string | null
  goal?: number | null
}

// A resposta completa do login, que inclui o token
export interface SignInResponse extends User {
  accessToken: string
}

export interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  signIn: (data: SignInResponse) => void
  signOut: () => void
}

export const useAuthStore = create(
  persist<AuthState>(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      signIn: (data) => {
        const { accessToken, ...user } = data
        set({ user, token: accessToken, isAuthenticated: true })
      },
      signOut: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: "auth-storage", // Nome da chave no localStorage
      storage: createJSONStorage(() => localStorage),
    },
  ),
)